import { render, staticRenderFns } from "./UploadedInvoiceView.vue?vue&type=template&id=2c20023c&scoped=true&"
import script from "./UploadedInvoiceView.vue?vue&type=script&lang=js&"
export * from "./UploadedInvoiceView.vue?vue&type=script&lang=js&"
import style0 from "./UploadedInvoiceView.vue?vue&type=style&index=0&id=2c20023c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20023c",
  null
  
)

export default component.exports